import useAdMediaQuery from "../../../api/codeValue/useAdMediaQuery"
import usePrefectureQuery from "../../../api/codeValue/usePrefectureQuery"
import useServiceToUseQuery from "../../../api/codeValue/useServiceToUseQuery"

const useSignUpCodeValueQueries = () => {
  const prefecture = usePrefectureQuery()
  const serviceToUse = useServiceToUseQuery()
  const userAdvertisingMediaCode = useAdMediaQuery()

  return { prefecture, serviceToUse, userAdvertisingMediaCode }
}

export default useSignUpCodeValueQueries
